var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#161616;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.2,10.5h-1.6V2.7L8.3,3.6V2.2L12,0.8h0.2V10.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,21.4H1.3v-1.1l3.2-3.5c0.5-0.5,0.8-0.9,1-1.3c0.2-0.3,0.3-0.7,0.3-1c0-0.5-0.1-0.8-0.4-1.1 c-0.3-0.3-0.6-0.4-1-0.4c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.4,0.8-0.4,1.3H1.1c0-0.6,0.1-1.1,0.4-1.6c0.3-0.5,0.6-0.8,1.1-1.1 c0.5-0.3,1.1-0.4,1.7-0.4c0.9,0,1.7,0.2,2.2,0.7s0.8,1.1,0.8,2c0,0.5-0.1,1-0.4,1.5s-0.7,1.1-1.3,1.8l-2.4,2.5h4.5V21.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,15.7h1c0.5,0,0.9-0.1,1.2-0.4c0.3-0.3,0.4-0.6,0.4-1.1c0-0.5-0.1-0.8-0.4-1.1s-0.6-0.4-1.1-0.4 c-0.4,0-0.8,0.1-1.1,0.4c-0.3,0.2-0.4,0.6-0.4,1h-1.6c0-0.5,0.1-0.9,0.4-1.4c0.3-0.4,0.6-0.7,1.1-1c0.5-0.2,1-0.3,1.6-0.3 c1,0,1.7,0.2,2.3,0.7s0.8,1.2,0.8,2c0,0.4-0.1,0.8-0.4,1.2s-0.6,0.7-1.1,0.9c0.5,0.2,0.9,0.5,1.2,0.9c0.3,0.4,0.4,0.9,0.4,1.4 c0,0.9-0.3,1.6-0.9,2.1c-0.6,0.5-1.4,0.8-2.3,0.8c-0.9,0-1.7-0.2-2.3-0.7c-0.6-0.5-0.9-1.2-0.9-2h1.6c0,0.4,0.1,0.8,0.4,1 s0.7,0.4,1.1,0.4c0.5,0,0.9-0.1,1.2-0.4c0.3-0.3,0.4-0.6,0.4-1.2c0-0.5-0.2-0.9-0.5-1.2S18.4,17,17.8,17h-0.9V15.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/Number.926b4366.svg";
export { ForwardRef as ReactComponent };